<template>
  <div class="page_jobTask">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="项目:">
              <el-select v-model="listQuery.ProjectId" size="small" filterable clearable placeholder="" style="width: 180px;">
                <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
                </el-option>
                <el-option label="全部" :value="0">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务部门">
              <el-input v-model="listQuery.serviceDepartment" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="客服">
              <el-input v-model="listQuery.customerService" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>结算</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName == '0' ? '原始单' : '生成单' }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="杰小薪设置" name="0"></el-tab-pane>
          <el-tab-pane label="杰小职设置" name="1"></el-tab-pane>
          <el-tab-pane label="杰小金设置" name="2"></el-tab-pane>
          <el-tab-pane label="任务缺省设置" name="3"></el-tab-pane>
          <!-- <el-tab-pane label="增强学习" name="4"></el-tab-pane> -->
          <el-tab-pane label="入职参保规则" name="5"></el-tab-pane>
          <el-tab-pane label="入职签约规则" name="6"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="expList" :loading="isExping">导出</el-button>
          <el-button type="warning" size="small" @click="uploadHandel">导入</el-button>
          <el-button type="success" size="small" @click="stopHandel('启用')" v-if="activeName">启用</el-button>
          <el-button type="danger" size="small" @click="stopHandel('停用')">停用</el-button>
          <el-button type="primary" size="small" @click="addProTask">+添加</el-button>
          <el-button type="danger" size="small" @click="delHandel">删除</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight - 100" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column prop="orderNumber" label="编号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="project" label="项目" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="status" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="employeeOperation" label="员工自助操作" min-width="240" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div v-html="row.employeeOperation"></div>
            </template>
          </el-table-column>
          <el-table-column prop="employeeOperationTime" label="员工自助操作自动流程允许时间" min-width="240" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="customerServiceOperation" label="客服操作" min-width="240" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div v-html="row.customerServiceOperation"></div>
            </template>
          </el-table-column>
          <el-table-column prop="customerServiceOperationTime" label="客服操作自动流程允许时间" min-width="240" :show-overflow-tooltip="true" align="center">

          </el-table-column>

          <el-table-column label="操作" fixed="right" align="center" width="280">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="timeSetHandel(row)">设置时间频次</el-button>
                <el-button type="text" size="small" @click="flowSetHandel(row)">自动流程设置</el-button>
                <el-button type="text" size="small" @click="emailSetHandel(row)">邮箱设置</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加 -->
    <el-dialog title="添加" :visible.sync="addTaskVisible" width="500px" class="res_dialog enter_dialog">
      <el-form ref="addTaskForm" :model="addTaskForm" class="" label-width="100px" size="small">
        <el-form-item label="项目:" prop="type">
          <el-select v-model="taskProject" placeholder="" style="width:300px" filterable @change="changeObj" value-key="Projectid">
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addTaskVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddTask" :loading="isbtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog title="导入" :visible.sync="uploadVisible" width="500px" class="res_dialog enter_dialog">
      <el-form :rules="uploadRules" ref="addTaskForm" :model="addTaskForm" class="" label-width="100px" size="small">
        <el-form-item label="导入Excel" prop="imp">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <div class="blueName cp" @click="downTemp">下载模板</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmUpload" :loading="isbtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 自动流程设置 -->
    <el-dialog title="自动流程设置" :visible.sync="flowSetVisible" width="700px" class="res_dialog enter_dialog">
      <el-form ref="flowForm" :model="flowForm" class="" label-width="100px" size="mini">
        <el-form-item label="项目:" prop="type">
          {{ flowForm.project }}
        </el-form-item>
        <div class="formTitle formTitle3 formTitle2 "><span>|</span> 员工自助操作 </div>

        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="flowForm.employee_1" :true-label="1" :false-label="0">允许自助到面登记</el-checkbox>
            <div class="pushItem">
              <el-checkbox v-model="flowForm.interviewPushNotification" :true-label="1" :false-label="0" :disabled="!flowForm.employee_1">推送面试须知</el-checkbox>
            </div>
          </div>
        </el-form-item>
        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="employee_2" :true-label="1" :false-label="0">允许自助入职登记</el-checkbox>
            <el-radio-group v-model="flowForm.employee_2" :disabled="!employee_2">
              <el-radio :label="1"> 待入职</el-radio>
              <el-radio :label="2"> 直接入职</el-radio>
            </el-radio-group>
          </div>
          <div class="pushItem" style="margin-left: 156px;">
            <el-checkbox v-model="flowForm.onboardingNotification" :true-label="1" :false-label="0" :disabled="!employee_2">推送入职培训须知</el-checkbox>
          </div>
        </el-form-item>

        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="employee_3" :true-label="1" :false-label="0">自助入职自动电子签约</el-checkbox>
            <el-radio-group v-model="flowForm.employee_3" :disabled="!employee_3">
              <el-radio :label="1"> 不发签约通知</el-radio>
              <el-radio :label="2"> 自动发送签约通知</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="employee_4" :true-label="1" :false-label="0">自助入职自动参保</el-checkbox>
            <el-radio-group v-model="flowForm.employee_4" :disabled="!employee_4">
              <el-radio :label="1"> 加保待确认</el-radio>
              <el-radio :label="2"> 无需确认，直接申请参保</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="employee_5" :true-label="1" :false-label="0">允许自助离职登记</el-checkbox>
            <el-radio-group v-model="flowForm.employee_5" :disabled="!employee_5">
              <el-radio :label="1"> 待离职</el-radio>
              <el-radio :label="2"> 直接离职</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="employee_6" :true-label="1" :false-label="0">自助离职自动电子签约</el-checkbox>
            <el-radio-group v-model="flowForm.employee_6" :disabled="!employee_6">
              <el-radio :label="1"> 不发签约通知</el-radio>
              <el-radio :label="2"> 自动发送签约通知</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="employee_7" :true-label="1" :false-label="0">自助离职自动减保</el-checkbox>
            <el-radio-group v-model="flowForm.employee_7" :disabled="!employee_7">
              <el-radio :label="1"> 减保待确认</el-radio>
              <el-radio :label="2"> 无需确认，直接申请减保</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>


        <div class="formTitle formTitle3 formTitle2 "><span>|</span> 客服操作 </div>

        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="customerService_1" :true-label="1" :false-label="0">入职登记自动电子签约</el-checkbox>
            <el-radio-group v-model="flowForm.customerService_1" :disabled="!customerService_1">
              <el-radio :label="1"> 不发签约通知</el-radio>
              <el-radio :label="2"> 自动发送签约通知</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="customerService_2" :true-label="1" :false-label="0">入职登记自动参保</el-checkbox>
            <el-radio-group v-model="flowForm.customerService_2" :disabled="!customerService_2">
              <el-radio :label="1"> 加保待确认</el-radio>
              <el-radio :label="2"> 无需确认，直接申请参保</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="customerService_3" :true-label="1" :false-label="0">离职登记自动电子签约</el-checkbox>
            <el-radio-group v-model="flowForm.customerService_3" :disabled="!customerService_3">
              <el-radio :label="1"> 不发签约通知</el-radio>
              <el-radio :label="2"> 自动发送签约通知</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item label-width="100px">
          <div class="empSetItem flex aic">
            <el-checkbox v-model="customerService_4" :true-label="1" :false-label="0">离职自动减保</el-checkbox>
            <el-radio-group v-model="flowForm.customerService_4" :disabled="!customerService_4">
              <el-radio :label="1"> 减保待确认</el-radio>
              <el-radio :label="2"> 无需确认，直接申请减保</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="flowSetVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSetFlow" :loading="isbtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 设置时间频次 -->
    <el-dialog title="设置时间频次" :visible.sync="frequencyVisible" width="750px" class="res_dialog enter_dialog">
      <el-form ref="frequencyForm" :model="frequencyForm" class="" v-if="frequencyVisible" label-width="100px" size="small">

        <div class="formTitle formTitle3" style="margin-bottom: 15px;"><span>|</span> 员工自助操作 </div>
        <el-form-item label="起止日期:" size="small">
          <div class="flex">
            <el-select v-model="addForm.unit" placeholder="" style="width:80px;margin-left: 10px;" @change="changeUnit">
              <el-option label="每天" :value="3"></el-option>
              <el-option label="每周" :value="2"></el-option>
              <el-option label="每月" :value="1"></el-option>
              <el-option label="每季度" :value="-1"></el-option>
              <el-option label="每年" :value="-2"></el-option>
            </el-select>
            <template v-if="addForm.unit==1 || addForm.unit==2">
              <el-select v-model="addForm.startData" placeholder="" filterable style="width:80px;margin-left: 10px;" v-if="addForm.unit==1">
                <el-option v-for="(item, index) in 30" :key="index" :label="item + '日'" :value="item"></el-option>
              </el-select>
              <el-select v-model="addForm.startData" placeholder="" filterable style="width:80px;margin-left: 10px;" v-if="addForm.unit==2">
                <el-option v-for="(item, index) in 7" :key="index" :label="'周 ' + item" :value="item"></el-option>
              </el-select>
              <span style="margin-left: 10px;"> ~ </span>
              <el-select v-model="addForm.endData" placeholder="" filterable style="width:80px;margin-left: 10px;" v-if="addForm.unit==1">
                <el-option v-for="(item, index) in 31" :key="index" :label="item + '日'" :value="item"></el-option>
              </el-select>
              <el-select v-model="addForm.endData" placeholder="" filterable style="width:80px;margin-left: 10px;" v-if="addForm.unit==2">
                <el-option v-for="(item, index) in 7" :key="index" :label="'周 ' + item" :value="item"></el-option>
              </el-select>
            </template>
            <el-time-picker v-model="addForm.startTime" format="HH:mm" value-format="HH:mm" placeholder="" style="width:100px;margin-left: 10px;">
            </el-time-picker>
            <span style="margin-left: 10px;"> ~ </span>
            <el-time-picker v-model="addForm.endTime" format="HH:mm" value-format="HH:mm" placeholder="" style="width:100px;margin-left: 10px;">
            </el-time-picker>
            <div class="blueName cp" @click="addTimeSet()" style="margin-left: 20px;">+添加</div>
          </div>
          <div v-for="(item, index) in frequencyForm.data" v-if="item.type==1" :key="index" class="flex" style="padding-left: 30px;">
            <span>{{ getTimeUnitText(item.unit) }} {{ item.startData }} ~ {{ item.endData }}</span>
            <span style="margin-left: 10px;">{{
              item.startTime }} ~ {{ item.endTime }}</span>
            <span class="blueName cp" style="margin-left: 20px;" @click="delTimeSet(index)">删除</span>
          </div>
        </el-form-item>


        <div class="formTitle formTitle3" style="margin-bottom: 15px;"><span>|</span> 客服操作 </div>

        <el-form-item label="起止日期:" size="small">
          <div class="flex">
            <el-select v-model="addForm2.unit" placeholder="" style="width:80px;margin-left: 10px;" @change="changeUnit">
              <el-option label="每天" :value="3"></el-option>
              <el-option label="每周" :value="2"></el-option>
              <el-option label="每月" :value="1"></el-option>
              <el-option label="每季度" :value="-1"></el-option>
              <el-option label="每年" :value="-2"></el-option>
            </el-select>
            <template v-if="addForm2.unit==1 || addForm2.unit==2">
              <el-select v-model="addForm2.startData" placeholder="" filterable style="width:80px;margin-left: 10px;" v-if="addForm2.unit==1">
                <el-option v-for="(item, index) in 30" :key="index" :label="item + '日'" :value="item"></el-option>
              </el-select>
              <el-select v-model="addForm2.startData" placeholder="" filterable style="width:80px;margin-left: 10px;" v-if="addForm2.unit==2">
                <el-option v-for="(item, index) in 7" :key="index" :label="'周 ' + item" :value="item"></el-option>
              </el-select>
              <span style="margin-left: 10px;"> ~ </span>
              <el-select v-model="addForm2.endData" placeholder="" filterable style="width:80px;margin-left: 10px;" v-if="addForm2.unit==1">
                <el-option v-for="(item, index) in 31" :key="index" :label="item + '日'" :value="item"></el-option>
              </el-select>
              <el-select v-model="addForm2.endData" placeholder="" filterable style="width:80px;margin-left: 10px;" v-if="addForm2.unit==2">
                <el-option v-for="(item, index) in 7" :key="index" :label="'周 ' + item" :value="item"></el-option>
              </el-select>
            </template>
            <el-time-picker v-model="addForm2.startTime" format="HH:mm" value-format="HH:mm" placeholder="" style="width:100px;margin-left: 10px;">
            </el-time-picker>
            <span style="margin-left: 10px;"> ~ </span>
            <el-time-picker v-model="addForm2.endTime" format="HH:mm" value-format="HH:mm" placeholder="" style="width:100px;margin-left: 10px;">
            </el-time-picker>
            <div class="blueName cp" @click="addTimeSet2()" style="margin-left: 20px;">+添加</div>
          </div>
          <div v-for="(item, index) in frequencyForm.data" v-if="item.type==2" :key="index" class="flex" style="padding-left: 30px;">
            <span>{{ getTimeUnitText(item.unit) }} {{ item.startData }} ~ {{ item.endData }}</span>
            <span style="margin-left: 10px;">{{
              item.startTime }} ~ {{ item.endTime }}</span>
            <span class="blueName cp" style="margin-left: 20px;" @click="delTimeSet(index)">删除</span>
          </div>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="frequencyVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSetFrequency" :loading="isbtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改邮箱" :visible.sync="showEmailSet" width="500px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="emailForm" :model="emailForm" class="" label-width="100px" size="small">
        <el-form-item label="接受邮箱">
          <el-input v-model="receiveEmail" size="small" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="发送邮箱">
          <el-input v-model="sendEmail" size="small" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="emailForm.password" size="small" style="width:300px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEmailSet = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmEmailSet" :loading="isbtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          pagination: {
            pageSize: 10,
            Page: 1,
            OrderInput: [{
              property: "status",
              order: 0
            }]
          },
          ProjectId: 0,
          serviceDepartment: '',
          EndTime: '',
          customerService: '',
        },
        receiveEmail: '', //接受邮箱
        sendEmail: '', //发送邮箱
        receiving_server: '',
        sending_server: '',
        addTaskForm: {
          projectId: '',
          projectName: '',
          status: '启用',
          TaskType: 10, //10结算单任务设置 20杰小职设置 30杰小金设置
        },
        taskProject: '',
        isExping: false,
        fileList: [],
        uploadVisible: false,
        showDropScreen: -1,
        activeName: '1',
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表
        multipleSelection: [],
        permissionLists: [],
        uploadRules: {},
        addTaskVisible: false,
        isbtnLoading: false,
        uploadForm: {
          fileUrl: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        flowSetVisible: false,
        projectName: '',
        employee_2: 0,
        employee_3: 0,
        employee_4: 0,
        employee_5: 0,
        employee_6: 0,
        employee_7: 0,
        customerService_1: 0,
        customerService_2: 0,
        customerService_3: 0,
        customerService_4: 0,
        flowForm: {
          employee_1: 0, //允许自助到面登记：1：是；0：否
          interviewPushNotification: 0, //推送面试须知：1：是；0：否
          employee_2: 0, //允许自助入职登记：0：否；1：待入职；2：直接入职
          onboardingNotification: 0, //推送入职培训须知：1：是；0：否
          employee_3: 0, //自助入职自动电子签约：0：否；1：不发签约通知；2：自动发送签约通知
          employee_4: 0, //自助入职自动参保：0：否；1：加保待确认；2：无需确认，直接申请参保
          employee_5: 0, //允许自助离职登记：0：否；1：待离职；2：直接离职
          employee_6: 0, //自助离职自动电子签约：0：否；1：不发签约通知；2：自动发送签约通知
          employee_7: 0, //自助离职自动减保：0：否；1：减保待确认；2：无需确认，直接申请减保
          customerService_1: 0, //入职登记自动电子签约0：否；1：不发签约通知；2：自动发送签约通知
          customerService_2: 0, //入职登记自动参保0：否；1：加保待确认；2：无需确认，直接申请参保
          customerService_3: 0, //离职登记自动电子签约0：否；1：不发签约通知；2：自动发送签约通知
          customerService_4: 0, //离职登记登记自动减保0：否；1：减保待确认；2：无需确认，直接申请减保
          processId: "",
          processModifier: Cookies.get("userid-b"),
        },
        frequencyVisible: false,
        frequencyForm: {
          processId: '',
          timeModifier: Cookies.get("userid-b"),
          data: [{
            type: 1, //类型1：员工自助操作2：客服操作
            unit: null, //单位-2：年-1：季度1：月2：周3：天
            startData: 0, //开始，按月：1~31日，按周：周一~周日，按天：0；0是无条件
            endData: 0, //结束，按月：1~31日，按周：周一~周日，按天：0；0是无条件
            startTime: '',
            endTime: '',
            timeId: '' //时间频次id
          }]
        },
        addForm: {
          type: 1,
          unit: '',
          startData: '',
          endData: '',
          startTime: '',
          endTime: '',
          timeId: ''
        },
        addForm2: {
          type: 2,
          unit: '',
          startData: '',
          endData: '',
          startTime: '',
          endTime: '',
          timeId: ''
        },
        showEmailSet: false,
        emailForm: {
          id: '',
          receiveEmail: '',
          sendEmail: '',
          password: ''
        },
        rules: {},
        modelList: [],
      }
    },
    created() {
      this.getList();
      this.getProList();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.pagination.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pagination.Page = 1;
        this.listQuery.pagination.pageSize = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pagination.Page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.TaskSetupFun(this.listQuery, 'GetEmploymentServicesList').then(res => {
          if (res.status === 'ok' && res.data.data != null) {
            res.data.data.forEach(e => {
              e.customerServiceOperation = e.customerServiceOperation.replace(/\n/g, '；<br/>')
              e.employeeOperation = e.employeeOperation.replace(/\n/g, '；<br/>')
            });
            this.tableData = res.data.data;
            this.totalCount = res.data.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.loading = false;
        })
      },
      safeParseJson(str, defaultValue) {
        try {
          return str ? JSON.parse(str) : defaultValue;
        } catch (e) {
          console.warn('Failed to parse JSON string:', str, 'Error:', e);
          return defaultValue;
        }
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        if (this.activeName == '0') {
          this.$router.push({
            path: '/settlementTask'
          })
        } else if (this.activeName == '1') {
          this.getList();
        } else if (this.activeName == '3') {
          this.$router.push({
            path: '/taskSet'
          })
        } else if (this.activeName == '4') {
          this.$router.push({
            path: '/dict'
          })
        } else if (this.activeName == '5' || this.activeName == '6') {
          this.$router.push({
            path: '/ruleSet',
            query: {
              activeName: this.activeName
            }
          })
        }
      },
      toDownFile(url) {
        const newWindow = window.open(url, "_blank");
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      uploadHandel() {
        this.uploadForm.fileUrl = '';
        this.fileList = [];
        this.isbtnLoading = false;
        this.uploadVisible = true;
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 删除附件
      handleFileRemove() {
        this.uploadForm.fileUrl = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.uploadForm.fileUrl = res;
          } else {
            this.uploadForm.fileUrl = ''
          }
        });
      },
      downTemp() {
        let path = this.$store.state.EMP.tablePath + 'excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20241223104534570.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "导入拆分模版.xlsx";
        aTag.click();
      },
      confirmUpload() {
        if (this.uploadForm.fileUrl) {
          this.isbtnLoading = true;
          xz.RPAFun(this.uploadForm, 'ImportStatementTaskSettings').then(res => {
            if (res.status == 'ok') {
              this.isbtnLoading = false;
              this.getList();
              this.uploadVisible = false;
              this.$message.success("导入成功！");
            } else {
              this.isbtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        }
      },
      addProTask() {
        this.addTaskForm = {
          projectId: '',
          projectName: '',
          status: '启用',
          TaskType: 10
        }
        this.taskProject = '';
        this.isbtnLoading = false;
        this.addTaskVisible = true;
      },
      changeObj(val) {
        this.addTaskForm.projectId = val.Projectid;
        this.addTaskForm.projectName = val.StrprojectName;
      },
      confirmAddTask() {
        if (this.addTaskForm.projectId) {
          let d = {
            projectId: this.addTaskForm.projectId,
            creator: Cookies.get("userid-b")
          }
          xz.TaskSetupFun(d, 'SetEmploymentServicesAdd').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.addTaskVisible = false;
              this.isbtnLoading = false;
              this.$message.success('添加成功！')
            } else {
              this.isbtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        } else {
          this.$message.warning('请选择项目')
        }
      },
      stopHandel(status) {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.id)
            if (i == this.multipleSelection.length - 1) {
              let d = {
                processId: arr,
                status: status == '启用' ? 0 : 1,
                processModifier: Cookies.get("userid-b")
              }
              xz.TaskSetupFun(d, 'SetEmploymentServicesDelete').then(res => {
                if (res.status == 'ok') {
                  this.getList();
                  this.loading = false;
                  this.$message.success('操作成功');
                } else {
                  this.loading = false;
                  this.$message.error(res.msg);
                }
              })
            }
          });
        } else {
          this.$message.warning('请至少选择一个任务')
        }
      },
      delHandel() {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.id)
            if (i == this.multipleSelection.length - 1) {
              let d = {
                id: arr
              }
              xz.RPAdel(d, 'DeleteTaskSetting').then(res => {
                if (res.status == 'ok') {
                  this.getList();
                  this.loading = false;
                  this.$message.success('删除成功');
                } else {
                  this.loading = false;
                  this.$message.error(res.msg);
                }
              })
            }
          });
        } else {
          this.$message.warning('请至少选择一个任务')
        }
      },
      expList() {
        this.isExping = true;
        xz.exportRPA(this.listQuery, 'ExportTaskSettings').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = "任务结算单设置导出.xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.isExping = false;
            this.$message.error('导出异常')
          }
        })
      },
      emailSetHandel(row) {
        this.receiveEmail = row.receiveEmail.length > 0 ? row.receiveEmail[0].EmailAddress : '';
        this.sendEmail = row.sendEmail.length > 0 ? row.sendEmail[0].EmailAddress : '';
        this.emailForm = {
          id: row.id,
          receiveEmail: row.receiveEmail,
          sendEmail: row.sendEmail,
          password: row.password
        }
        this.showEmailSet = true;
      },
      confirmEmailSet() {
        if (this.emailForm.receiveEmail.length > 0) {
          this.emailForm.receiveEmail[0].EmailAddress = this.receiveEmail;
          this.emailForm.receiveEmail = JSON.stringify(this.emailForm.receiveEmail)
        } else {
          this.emailForm.receiveEmail = [{
            EmailAddress: this.receiveEmail,
            StartTime: '',
            endTime: '',
            pwd: '',
            Encryptpwd: '',
          }]
          this.emailForm.receiveEmail = JSON.stringify(this.emailForm.receiveEmail)
        }
        if (this.emailForm.sendEmail.length > 0) {
          this.emailForm.sendEmail[0].EmailAddress = this.sendEmail;
          this.emailForm.sendEmail = JSON.stringify(this.emailForm.sendEmail)
        } else {
          this.emailForm.sendEmail = [{
            EmailAddress: this.sendEmail,
            StartTime: '',
            endTime: '',
            pwd: '',
            Encryptpwd: '',
          }]
        }
        this.isbtnLoading = true;
        xz.RPAFun(this.emailForm, 'SetEmail').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功');
            this.showEmailSet = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      flowSetHandel(row) {
        let str = `GetEmploymentServicesEdit?ProcessId=${row.processId}`;
        xz.TaskSetupGetFun(str)
          .then(res => {
            if (res.status === 'ok' && res.data) {
              this.flowForm = res.data;
              this.flowForm.processId = row.processId;
              this.flowForm.processModifier = Cookies.get("userid-b");
              // 定义需要处理的字段列表
              const employeeFields = [
                'employee_2', 'employee_3', 'employee_4',
                'employee_5', 'employee_6', 'employee_7'
              ];
              const customerServiceFields = [
                'customerService_1', 'customerService_2',
                'customerService_3', 'customerService_4'
              ];

              // 统一处理逻辑
              [...employeeFields, ...customerServiceFields].forEach(field => {
                if (res.data[field] != 0) {
                  this[field] = 1;
                }
              });
              this.flowSetVisible = true;
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(err => {
            console.error('请求失败:', err);
          });
      },
      confirmSetFlow() {
        this.isbtnLoading = true;
        xz.TaskSetupFun(this.flowForm, 'SetEmploymentServicesSave').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功');
            this.flowSetVisible = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      timeSetHandel(row) {
        let str = `GetEmploymentServicesTimeEdit?ProcessId=${row.processId}`;
        xz.TaskSetupGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.frequencyForm.data = res.data.data;
          }
        })
        this.frequencyForm.processId = row.processId;
        this.isbtnLoading = false;
        this.frequencyVisible = true;
        console.log(this.frequencyForm)
      },
      addTimeSet() {
        if (this.addForm.unit && this.addForm.startTime && this.addForm.endTime) {
          this.frequencyForm.data.push(this.addForm)
          this.addForm = {
            type: 1,
            unit: '',
            startData: '',
            endData: '',
            startTime: '',
            endTime: '',
            timeId: ''
          }
        } else {
          this.$message.warning('请完善起止日期')
        }
      },
      addTimeSet2() {
        if (this.addForm2.unit && this.addForm2.startTime && this.addForm2.endTime) {
          this.frequencyForm.data.push(this.addForm2)
          this.addForm2 = {
            type: 2,
            unit: '',
            startData: '',
            endData: '',
            startTime: '',
            endTime: '',
            timeId: ''
          }
        } else {
          this.$message.warning('请完善起止日期')
        }
      },
      delTimeSet(i) {
        this.frequencyForm.data.splice(i, 1)
      },
      confirmSetFrequency() {
        if (this.addForm.unit) {
          this.addTimeSet();
        }
        if (this.addForm2.unit) {
          this.addTimeSet2();
        }
        xz.TaskSetupFun(this.frequencyForm, 'SetEmploymentServicesTimeSave').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功');
            this.frequencyVisible = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      getFrequencyVal(val) {
        let v = JSON.parse(val);
        try {
          return v.显示文本
        } catch {
          return ''
        }
      },
      getTimeUnitText(unitNumber) {
        const unitMap = {
          '-2': '每年',
          '-1': '每季度',
          '1': '每月',
          '2': '每周',
          '3': '每天'
        };
        return unitMap[unitNumber] || '';
      },
      changeUnit(val) {
        if (val == 1 || val == 2) {
          this.addForm.startData = null;
          this.addForm.endData = null;
        } else {
          this.addForm.startData = 0;
          this.addForm.endData = 0;
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .expandTable {
    padding-left: 50px;
  }


  .formTitle {
    font-weight: 600;
    font-size: 14px;
  }

  .formTitle span {
    color: #F59A23;
    font-size: 18px;
  }

  .formTitle2 {
    margin-left: 50px;
    margin-bottom: 15px;
  }

  .formTitle3 span {
    color: #19BD92;
    font-size: 18px;
  }
</style>
<style>
  .page_jobTask .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_jobTask .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_jobTask .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_jobTask .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_jobTask .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_jobTask .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_jobTask .empSetItem .el-checkbox__label {
    margin-right: 20px;
    font-weight: 550;
  }

  .page_jobTask .pushItem .el-checkbox__label {
    font-weight: 400;
    font-size: 13px;
  }
</style>